import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers/index';
import type { RootState } from '../reducers/index';
import { loadState, saveState } from '../services/local-storage';

const persistedState = loadState() as RootState | undefined;

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  // @ts-ignore TS2719: RTK Tuple conflict with untyped redux-logger in mixed JS/TS codebase
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(createLogger()),
  devTools: process.env.NODE_ENV !== 'production',
});

const saveStateWrapper = (): void => {
  // clear auth state prior to save
  saveState({
    ...store.getState(),
    admin: { importData: [], importInProgress: false, importResult: null, importErrors: null },
  });
};

store.subscribe(saveStateWrapper);

export type AppDispatch = typeof store.dispatch;
export { RootState };
export default store;
